export { IntentPrefetchLink } from "./IntentPrefetchLink";
